module.exports = __webpack_public_path__ + "img/Group_217_sm.06344926.png";